import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Transaccion, Categoria } from '../types';
import { computa } from '../utils/transaccionUtils';
import { formatoEuros } from '../utils/numeros';

interface GraficoGastosProps {
  transacciones: Transaccion[];
  categorias: Categoria[];
}

export const GraficoGastos: React.FC<GraficoGastosProps> = ({ transacciones, categorias }) => {
  const ahora = new Date();
  const gastosMes = transacciones.filter(t => {
    const fecha = new Date(t.fecha);
    return fecha.getMonth() === ahora.getMonth() &&
           fecha.getFullYear() === ahora.getFullYear() &&
           t.tipo === 'gasto' &&
           computa(t); // excluir movimientos de traspaso y adelantos
  });

  const gastosPorCategoria: { [key: string]: number } = {};
  gastosMes.forEach(gasto => {
    if (!gastosPorCategoria[gasto.categoriaId]) {
      gastosPorCategoria[gasto.categoriaId] = 0;
    }
    gastosPorCategoria[gasto.categoriaId] += gasto.cantidad;
  });

  const datos = Object.entries(gastosPorCategoria).map(([id, cantidad]) => {
    const categoria = categorias.find(c => c.id === id);
    return {
      name: categoria ? `${categoria.icono} ${categoria.nombre}` : 'Sin categoría',
      value: cantidad,
      color: categoria?.color,
    };
  });

  // Paleta nórdica: fiordo, baya, musgo, ámbar, brezo, lumbre, lago, arcilla
  const COLORS = ['#3E5C76', '#B5473A', '#5E7D5A', '#C9963A', '#7A6A8F', '#C8794A', '#4F8A8B', '#B5653E'];

  if (datos.length === 0) {
    return (
      <div className="text-center text-gray-500 dark:text-gray-400 py-8">
        No hay gastos este mes
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={datos}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#3E5C76"
          dataKey="value"
        >
          {datos.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color || COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip
          formatter={(value, name) => [formatoEuros(Number(value)), name]}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
